import * as React from 'react';
import {useRoute} from 'react-router5';
import {TaskBuilder} from 'components/TaskBuilder';
import {Helmet} from 'react-helmet';

/**
 * The edit task page
 * @constructor
 */
export default function EditTask(): React.ReactElement {
  const {route: {params}, router} = useRoute();

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Редактировать задание</title>
      </Helmet>
      <TaskBuilder
        onUpdate={(id) => (
          router.navigate('tasks.task.edit', {
            id,
          })
        )}
      />
    </React.Fragment>
  );
}
